import { throttle } from 'throttle-debounce';

const ELEMENT = '.js--fix-position';

export default function fixPosition() {
    const el = document.querySelector(ELEMENT);
    if (!el) {
        return false;
    }
    const initialElPos = window.pageYOffset + el.getBoundingClientRect().top;

    const initStickyElement = () => {
        function setElementState() {
            const currentElPos = el.getBoundingClientRect().top;
            const footerPos =
                document.querySelector('.pagelinks__container')?.getBoundingClientRect().top || document.querySelector('.footer')?.getBoundingClientRect().top;
            const FOOTER_PADDING = 400;
            const TOP_PADDING = 5;
            const isEnoughForSticky = currentElPos < TOP_PADDING && window.pageYOffset > initialElPos && footerPos > FOOTER_PADDING;
            if (isEnoughForSticky) {
                el.style.paddingTop = '175px';
                el.style.top = '0';
                el.classList.add('fixed-position');
            } else {
                el.classList.remove('fixed-position');
                el.style.paddingTop = '0';
            }
        }

        setElementState();
        document.addEventListener('scroll', throttle(50, setElementState));
    };

    initStickyElement();
}
